import Icon, { WarningFillIcon } from '@design-systems/react-icons'

const ErrorBanner = (props) => {
  return (
    <div className="align-centre-left hc8-clr-error banner">
      <Icon
        svg={WarningFillIcon}
        className="hc8-clr-error hc8-mh-2x"
        size="lg"
        aria-hidden
      />
      <label
        className="hc8-clr-error hc8-fs-050 hc8-pv-2x hc8-pr-2x"
        dangerouslySetInnerHTML={{
          __html: [props.message],
        }}
      ></label>
    </div>
  )
}
export default ErrorBanner
